import {updateVariableTokens} from "./enhanced-editor/base";
import {showFlash, translate} from "./functions";

const otherCity = function (elt) {
    var city = $(elt);
    var value = city.find('option:checked').val();
    var myClass = "";
    if (city.hasClass('lead-city')) {
        myClass = 'lead-city';
    }

    if (value === 'other') {
        var newCity = '<input autocomplete="new-password" data-email="demande_ville" type="text" name="' + city.attr('name')
            + '" id="' + city.attr('id')
            + '" class="' + myClass
            + '"/>';
        city.parents('.form-line').find('.select2-container').remove();
        city.replaceWith(newCity).ready(function () {
            cityAutocomplete($('.lead-city'));
        });
        $(city).focus();

        $('#lead_customer_address_zipcode').bind('blur', function () {
            getCities(this, $('#lead_customer_address_city'));
        });

        $('#lead_customer_address_city').bind('blur', function () {
            getZipcodes(this, $('#lead_customer_address_zipcode'));
        });


        $('.lead-zip').bind('blur', function () {
            var city = $(this).parents('.field').next().find('.lead-city');
            getCities(this, city);
        });

        $('.lead-city').bind('blur', function () {
            var city = $(this).parents('.field').prev().find('.lead-zip');
            getZipcodes(this, city);
        });
    }
};

// Le champ reste un input libre : l'utilisateur peut continuer, mais doit savoir que la liste n'est pas venue.
function reportLookupFailure(lookup, xhr) {
    console.error(lookup + ' indisponibles (HTTP ' + xhr.status + ').');
    showFlash($('.js-flash-message-error').first(), translate('app.error.generic'), true);
}

/**
 * @param {Function|null} onReplaced appelé avec le nouveau select : le champ ville est remplacé dans le DOM,
 *                                   toute référence jQuery gardée par l'appelant devient obsolète.
 */
export function getCities(zipCodeElt, cityElt, onReplaced = null) {
    let zipcode = $(zipCodeElt);
    let city = $(cityElt);
    let myClass = "";
    if(city.hasClass('lead-city')) {
        myClass = 'lead-city';
    }

    if(typeof zipcode.val() != 'undefined' ) {
        let zipcodeVal = zipcode.val().trim().replace(/[^0-9a-z]/gi, '');
        if(zipcodeVal.length === 5) {
            $.ajax({
                type: "GET",
                url: Routing.generate('cities_list', {'zipcode': zipcodeVal}),
                success: function(response){
                    if(response.data.htmlContent !== '') {
                        let elt_id = city.attr('id');
                        let newCity = '<select name="' + city.attr('name') + '" id="' + elt_id + '" class="select2 ' + myClass +'" data-email="demande_ville">' + response.data.htmlContent + '</select>';
                        city.parents('.form-line').find('.select2-container').remove();
                        // Hors .form-line (tarifs PDV), le select2 d'un précédent remplacement resterait affiché.
                        city.next('.select2-container').remove();
                        city.replaceWith(newCity);
                        updateVariableTokens();
                        $('#' + elt_id).select2().focus().change(function() {
                            otherCity(this);
                        });
                        onReplaced?.($('#' + elt_id));
                    }
                },
                error: function(xhr) {
                    reportLookupFailure('Villes du code postal ' + zipcodeVal, xhr);
                }
            });
        }
    }
}

/**
 * @param {Function|null} onReplaced appelé avec le nouveau select (champ code postal remplacé dans le DOM).
 */
export function getZipcodes(cityElt, zipCodeElt, onReplaced = null) {

    let zipcode = $(zipCodeElt);
    let city = $(cityElt);
    let myClass = "";
    if(zipcode.hasClass('lead-zip')) {
        myClass = 'lead-zip';
    }

    if(typeof city.val() != 'undefined' ) {
        let ciyVal = city.val().trim().replace(/[^0-9a-z]/gi, '');
        if(ciyVal.length > 3) {
            $.ajax({
                type: "GET",
                url: Routing.generate('zipcodes_list', {'city': ciyVal}),
                success: function(response){
                    if(response.data.htmlContent !== '') {
                        let elt_id = zipcode.attr('id');
                        let newZipcode = '<select name="' + zipcode.attr('name') + '" id="' + elt_id + '" class="select2 ' + myClass +'" data-email="demande_code_postal">' + response.data.htmlContent + '</select>';
                        zipcode.parents('.form-line').find('.select2-container').remove();
                        zipcode.next('.select2-container').remove();
                        zipcode.replaceWith(newZipcode);
                        updateVariableTokens();
                        $('#' +  elt_id).select2().focus().change(function() {
                            otherCity(this);
                        });
                        onReplaced?.($('#' + elt_id));
                    }
                },
                error: function(xhr) {
                    reportLookupFailure('Codes postaux de la ville ' + ciyVal, xhr);
                }
            });
        }
    }
}

/**
 * @param {string|null} zipcodeSelector champ code postal à renseigner ; par défaut le `.lead-zip` du même `.city-zipcode`.
 */
export function cityAutocomplete(element, zipcodeSelector = null)
{
    element.autocomplete({
        source : Routing.generate('ajax_search_city'),

        select : function(event, ui) {
            const zipcode = zipcodeSelector ? $(zipcodeSelector) : $(this).parents('.city-zipcode').find('.lead-zip');
            zipcode.val(ui.item.zipcode).trigger('change');
        },

        minLength : 3
    });
    element.attr('autocomplete', 'new-password');
}

$(function() {

    if ($('#lead_customer_zipCode').length > 0 && $('#lead_customer_city').length > 0) {

        $('#lead_customer_zipCode').bind('keyup', function() {
            getCities(this, $('#lead_customer_city'));
        });

        $('#lead_customer_city').bind('blur', function() {
            getZipcodes(this, $('#lead_customer_zipCode'));
        });

    }

    if ($('.lead-city').length > 0) {
        cityAutocomplete($('.lead-city'))
    }

});

export function cityZipcode($element) {
    $element.find('.lead-zip').bind('blur', function() {
        let city = $(this).parents('.city-zipcode').find('.lead-city');
        if (city.val() === '') {
            getCities(this, city);
        }
    });

    $element.find('.lead-city').bind('blur', function() {
        this.value = this.value.toUpperCase();
        let zipcode = $(this).parents('.city-zipcode').find('.lead-zip');
        if (zipcode.val() === '') {
            getZipcodes(this, zipcode);
        }
    });

    $element.find('.lead-city').bind('keyup', function() {
        cityAutocomplete($(this))
    });
}